import { Modal, ModalBody } from '@customerio/pluma-components/react';
import { VideoDirectory } from './components/video-directory';
import { VideoViewer } from './components/video-viewer';
import { useVideoData } from './hooks/use-video-data';
import { useVideoLibrary } from './video-library-context';
import * as styles from './video-library.css';

export function VideoLibrary() {
  const { isOpen, activeVideoId, setActiveVideoId, closeVideoLibrary } = useVideoLibrary();
  const { data: videos = [], isLoading, isError, refetch } = useVideoData();

  const handleSelectVideo = (videoId: string) => {
    setActiveVideoId(videoId);
  };

  const handleViewAll = () => {
    setActiveVideoId(null);
  };

  const handleClose = () => {
    closeVideoLibrary();
  };

  const handleCloseComplete = () => {
    setActiveVideoId(null);
  };

  const handleRetry = () => {
    void refetch();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      onCloseComplete={handleCloseComplete}
      title="Customer.io Basics"
      className={styles.modal}
      data-test-video-library-modal
    >
      <ModalBody>
        {activeVideoId != null ? (
          <VideoViewer
            videoId={activeVideoId}
            videos={videos}
            onSelectVideo={handleSelectVideo}
            onViewAll={handleViewAll}
          />
        ) : (
          <VideoDirectory
            videos={videos}
            isLoading={isLoading}
            isError={isError}
            onSelectVideo={handleSelectVideo}
            onRetry={handleRetry}
          />
        )}
      </ModalBody>
    </Modal>
  );
}
